module.exports = __webpack_public_path__ + "images/syuccho_kaitori_lp/cases/q1_97e3be72a67d72418a5eede535b76d5d.png";